import { Box, Container, Heading, Icon, Image, Stack, Text } from '@chakra-ui/react'
import Logo from '../../assets/images/logo.png'
import { FaFacebookF, FaTwitter, FaGooglePlusG, FaLinkedinIn, FaInstagram } from 'react-icons/fa'
import GooglePlay from '../../assets/images/footer/01.png'
import ApplePlay from '../../assets/images/footer/02.png'
import { HiOutlineMail, HiOutlinePhone, HiLocationMarker } from 'react-icons/hi'
import { Link } from 'react-router-dom'
import { AiFillYoutube } from 'react-icons/ai'
import FooterLines from '../../assets/images/footerlines.png'

export default function index() {
  return (
    <Stack>
      <Stack
        position={'relative'}
        _before={{
          bgImage: FooterLines,
          content: "''",
          position: 'absolute',
          opacity: 0.1,
          top: 0,
          left: 0,
          display: 'block',
          width: '100%',
          height: '100%',
          bgAttachment: 'fixed',
          bgRepeat: 'no-repeat',
          bgPosition: 'center',
          bgSize: 'cover'
        }}
        backgroundColor={'#374455'}
        paddingY={'40px'}
      >
        <Container maxW={'7xl'} position={'relative'} zIndex={2}>
          <Stack
            direction={{ base: 'column', md: 'row' }}
            justifyContent={{ base: 'center', md: 'space-between' }}
            alignItems={{base: 'center', lg: 'flex-start'}}
          >
            <Box
              display={{ base: 'none', md: 'block' }}
            >
              {/* <Image src={Logo} w={'100%'} marginBottom={'30px'} /> */}
              <Box
                display={'flex'}
                alignItems={'center'}
                gap={2}
                className="socialLinks"
              >
                <a href='https://www.facebook.com/MASWTInternational?mibextid=LQQJ4d' target={'_blank'} ><Icon as={FaFacebookF} /></a>
                <a href='https://youtube.com/@mujaddidalfsaniwelfaretrus4003' target={'_blank'} style={{ fontSize: 28 }} ><Icon as={AiFillYoutube} /></a>
              </Box>
            </Box>
            <Box
              w={{ base: '48%', md: '24%' }}
              paddingBottom={'50px'}
              textAlign={'center'}
            >
              <Heading
                color={'#fff'}
                fontWeight={'500'}
                pb={'30px'}
                fontSize={{ base: '24px', md: '28px' }}
              >Explore</Heading>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/'}>Home</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/about'}>About Us</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/all-services'}>Our Services</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/all-projects'}>Future Projects</Link></Text>
            </Box>
            <Box
              w={{ base: '48%', md: '24%' }}
              textAlign={'center'}
              paddingBottom={'50px'}
              margin={'0 !important'}
            >
              <Heading
                color={'#fff'}
                fontWeight={'500'}
                pb={'30px'}
                fontSize={{ base: '24px', md: '28px' }}
              >Quick Links</Heading>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/news'}>News</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/online-donate'}>Donation</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/contact'}>Contact Us</Link></Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Link to={'/'}>Privacy Policy</Link></Text>
            </Box>
            <Box
              w={{ base: '48%', md: '24%' }}
              paddingBottom={'50px'}
            >
              <Heading
                color={'#fff'}
                fontWeight={'500'}
                pb={'30px'}
                fontSize={{ base: '24px', md: '28px' }}
              >Contact Us</Heading>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiLocationMarker} />Plot No. 83, Sector 4/F, Mujahid Colony, Orangi Town, Karachi-Pakistan.</Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiOutlineMail} />info@mujaddidalifsani.com</Text>
              <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiOutlinePhone} />(0092) 300 2230155</Text>
            </Box>
          </Stack>
          <Stack
            w={'100%'}
            justifyContent={'center'}
            borderTop={'1px solid #fff'}
            alignItems={'center'}
          >
            {/* <Heading
              color={'#fff'}
              fontWeight={'500'}
              pb={'30px'}
              fontSize={{ base: '24px', md: '28px' }}
            >Contact Us (UK)</Heading>
            <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiLocationMarker} />20 Gunthorpe Drive, Sherwood Nottingham, NG5 3DW</Text>
            <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiOutlineMail} />info@mujaddidalifsani.com</Text>
            <Text fontSize={{ base: '14px', md: '15px' }} color={'#fff'} pb={'15px'}><Icon mb={'-3px'} mr={'8px'} as={HiOutlinePhone} />(0044) 797 2377903</Text> */}

          </Stack>
          <Stack
            paddingY={'35px'}
            paddingBottom={'0'}
            borderTop={'1px solid #fff'}
          >
            <Text fontSize={{ base: '14px', md: '15px' }}
              color={'#fff'}
              textAlign={'center'}
            >&copy; 2024 Mujaddid Alf Sani. All Rigths Reserved.</Text>
          </Stack>
        </Container>
      </Stack>

    </Stack>
  )
}
